import { render } from "./SyncAdvLog.vue?vue&type=template&id=94e7a70a"
import script from "./SyncAdvLog.vue?vue&type=script&lang=js"
export * from "./SyncAdvLog.vue?vue&type=script&lang=js"

import "./SyncAdvLog.vue?vue&type=style&index=0&id=94e7a70a&lang=less"

import exportComponent from "/Users/islibaodong/IdeaProjects/2024/Titan-Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__